/* eslint-disable import/prefer-default-export */
import { useState } from 'react';
import { uploadService } from '@services/index';
import { CamelToSnakeCaseNested } from '@helpers/index';

type Upload = CamelToSnakeCaseNested<{
  id: number;
  fileType: string;
  fileName: string;
  fileExtension: string;
  status: string | null;
  processingResult: string | null;
  url: string;
  fileUrl: string;
}>;

export const useUploadFile = () => {
  const { useCreateUploadMutation } = uploadService;
  const [createUpload] = useCreateUploadMutation();
  const [uploadId, setUploadId] = useState<string | number>('');
  const [upload, setUpload] = useState<Upload>();

  const uploadFile = async (file: FormData) => {
    const response = await createUpload(file).unwrap();
    setUploadId(response.id);
    setUpload(response);
  };
  return { upload, uploadId, uploadFile };
};
